import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import UserFields from './UserFields'

export const UserEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <UserFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default UserEdit
